import { ButtonProps } from "@chakra-ui/react";
import { AccountType } from "@syla/shared/types/models/AccountBase";
import React from "react";
import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import { SingleSelector } from "../../components/selector/SingleSelector";

export function AccountTypeSelector({
  currentValue,
  onSelected,
  isLoading,
  isDisabled,
  ...props
}: {
  currentValue: AccountType | undefined;
  onSelected: (value: AccountType) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
} & ButtonProps) {
  const values = Object.values(AccountType);

  const options: StandardSelectOption<AccountType>[] = values.map((role) => ({
    value: role,
    data: {
      label: AccountType[role],
    },
  }));

  return (
    <SingleSelector
      options={options}
      value={currentValue}
      onChange={onSelected}
      isLoading={isLoading}
      isDisabled={isDisabled}
      buttonProps={props}
    />
  );
}
